import { CallToActionButton } from 'components/shared/callToActionButton/CallToActionButton';
import Logo from 'components/shared/logo/Logo';
import { useKioskManager } from 'hooks/useKioskManager';
import { useNetworkManager } from 'hooks/useNetworkManager';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ensureHttps } from 'utils/url';

import styles from './sectionCallToAction.module.scss';

type SectionAppBannerProps = {
  hideCallToAction?: boolean;
  orientation?: 'horizontal' | 'vertical';
  origin: string;
};

const SectionCallToAction: React.FC<SectionAppBannerProps> = ({
  hideCallToAction = false,
  orientation = 'horizontal',
  origin,
}) => {
  const { t } = useTranslation('common');
  const { kiosk, kioskMode } = useKioskManager();
  const { brandingData, siteName, siteLogo } = useNetworkManager();

  if (hideCallToAction) return null;

  if (orientation === 'horizontal') {
    return (
      <div
        role="banner"
        className={`${styles.section} ${
          kiosk && kioskMode && styles[kiosk.model]
        }`}
      >
        {brandingData && (
          <img
            className={styles.promoImage}
            src={ensureHttps(brandingData[0].install_app_cta_image)}
            alt="App Preview"
          />
        )}
        <div className={styles.contentColumn}>
          <div className={styles.campus}>
            <h1 className={styles.campusName}>{siteName}</h1>
          </div>
          <h2 className={styles.appTitle}>
            {t('appBanner.title', { campusName: siteName })}
          </h2>
          <p className={styles.appSubtitle}>
            {t('appBanner.subtitle', { appName: siteName })}
          </p>
          <CallToActionButton origin={origin} />
        </div>
      </div>
    );
  }
  if (orientation === 'vertical') {
    return (
      <div
        role="banner"
        className={`${styles.section} ${styles.verticalOrientation} ${
          kiosk && kioskMode && styles[kiosk.model]
        }`}
      >
        <div className={styles.contentColumn}>
          <Logo imageURL={siteLogo} companyName={siteName} />
          <div className={styles.campus}>
            <h1 className={styles.campusName}>{siteName}</h1>
          </div>
          <h2 className={styles.verticalAppTitle}>
            {t('appBanner.title', { campusName: siteName })}
          </h2>
          <p className={styles.verticalAppSubtitle}>
            {t('appBanner.subtitle', { appName: siteName })}
          </p>
          <CallToActionButton origin={origin} />
        </div>
        {brandingData && (
          <img
            className={styles.verticalPromoImage}
            src={ensureHttps(brandingData[0].install_app_cta_image)}
            alt="App Preview"
          />
        )}
      </div>
    );
  }
  return null;
};

export default memo(SectionCallToAction);
